<template>
  <a-divider>查询二维码</a-divider>
  <a-descriptions class="labelCenter" :column="1">
    <a-descriptions-item label="当前设备二维码">
      <a-space>
        <span v-if="!editState">{{ sing.currentCode.qrCode }}</span>
        <a-input allowClear v-model:value="codeValue" :style="{width:'120px'}" v-else></a-input>
        <a-button v-if="!editState" type="primary" @click="editStart" shape="circle" size="small">
          <EditOutlined/>
        </a-button>
        <a-button v-else type="primary" @click="submit" shape="circle" size="small">
          <CheckOutlined/>
        </a-button>
        <a-tooltip title="打开项目看板"  color="#2db7f5">
          <a-button type="primary" @click="projectState = true" shape="circle" size="small">
            <FundProjectionScreenOutlined/>
          </a-button>
        </a-tooltip>
        <span v-if="sing.currentCode.is">无归属设备</span>
      </a-space>
    </a-descriptions-item>
  </a-descriptions>
  <a-divider>项目信息</a-divider>
  <!--  项目信息  -->
  <a-descriptions :column="1" class="labelCenter">
    <a-descriptions-item label="项目名称">{{ user.buildName }}({{ user.buildId }})</a-descriptions-item>
    <a-descriptions-item label="项目版本">GOS{{ user.systemVersion }}</a-descriptions-item>
    <a-descriptions-item label="项目归属">{{ user.cityName }}</a-descriptions-item>
  </a-descriptions>
  <a-divider>设备查询</a-divider>
  <!--  设备查询  -->
  <a-descriptions :column="1" class="labelCenter">
    <a-descriptions-item label="设备地图">
      <a-space>
        <a-tooltip title="打开设备地图" color="#2db7f5">
          <a-button type="primary" @click="beefindMap" shape="circle" size="small" :icon="h(EnvironmentOutlined)"/>
        </a-tooltip>
      </a-space>
      <a-space style="margin-left: 20px">
        <a-tooltip  title="查看sim列表" color="#2db7f5">
          <a-button  type="primary" @click="beefindParkMap" shape="circle" size="small" :icon="h(CreditCardOutlined)"/>
        </a-tooltip>
      </a-space>
    </a-descriptions-item>
    <a-descriptions-item label="搜索项目设备">
      <a-input-search
          v-model:value="dev.devId"
          placeholder="输入设备id或者二维码"
          style="width: 240px"
          @search="dev.devChange"
          allow-clear
          @keydown="handleKey"
      />
    </a-descriptions-item>
  </a-descriptions>
  <!--  设备筛选  -->
  <a-collapse
      v-model:activeKey="activeKey"
      :bordered="false"
      style="background: hsl(180deg, 23%, 97%)"
  >
    <template #expandIcon="{ isActive }">
      <caret-right-outlined :rotate="isActive ? 90 : 0"/>
    </template>
    <a-collapse-panel key="1" header="展开筛选面板" style="border: none">
      <a-descriptions :column="3" class="labelCenter" layout="vertical">
        <a-descriptions-item label="主设备">
          <a-select
              v-model:value="allDev.primaryDevice"
              :options="modularDev.primaryOptions"
              mode="multiple"
              :size="size"
              placeholder="select"
              style="width: 100px"
              @change="dev.devChange"
          ></a-select>
        </a-descriptions-item>
        <a-descriptions-item label="模块化设备">
          <a-select
              v-model:value="allDev.modularEquipment"
              :options="modularDev.modularOptions"
              mode="multiple"
              :size="size"
              placeholder="select"
              style="width: 100px"
              @change="dev.devChange"
          ></a-select>
        </a-descriptions-item>
        <a-descriptions-item label="主副节点筛选">
          <a-select
              v-model:value="allDev.primaryAndSecondaryNodes"
              style="width: 100px"
              placeholder="select"
              @change="dev.devChange"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">主节点</a-select-option>
            <a-select-option :value="2">辅节点</a-select-option>
            <a-select-option :value="3">未绑定</a-select-option>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="标记筛选">
          <a-select
              v-model:value="allDev.tagFiltering"
              style="width: 100px"
              placeholder="select"
              @change="dev.devChange"
              mode="multiple"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="index" v-for="index in 6" :key="index">
              <a-image :preview="false" :width="25" :src="devTagUrl(index)"></a-image>
            </a-select-option>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="状态筛选">
          <a-select
              v-model:value="allDev.statusFiltering"
              style="width: 100px"
              placeholder="select"
              @change="dev.devChange"
          >
            <a-select-option :value="3">全部</a-select-option>
            <a-select-option :value="1">在线</a-select-option>
            <a-select-option :value="0">掉线</a-select-option>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="车位框筛选">
          <a-select
              v-model:value="allDev.parkingSpaceBoxFiltering"
              style="width: 100px"
              placeholder="select"
              @change="dev.devChange"
          >
            <a-select-option :value="3">全部</a-select-option>
            <a-select-option :value="1">已拖框</a-select-option>
            <a-select-option :value="0">未拖框</a-select-option>
          </a-select>
        </a-descriptions-item>
      </a-descriptions>
    </a-collapse-panel>
  </a-collapse>
  <a-divider>
    设备列表
    <a-tooltip title="刷新设备列表" color="#2db7f5">
      <a-button type="primary" @click="dev.getDevStoreList" shape="circle" size="small" :icon="h(RedoOutlined)"/>
    </a-tooltip>
  </a-divider>
  <!--  设备列表  -->
  <a-collapse
      v-model:activeKey="devKey"
      :bordered="false"
      style="background: hsl(180deg, 23%, 97%);"
      class="devBox"
      v-if="Object.keys(devInfo.devListInfo).length"
  >
    <template #expandIcon="{ isActive }">
      <caret-right-outlined :rotate="isActive ? 90 : 0"/>
    </template>
    <a-collapse-panel :key="index.toString()" v-for="(item,index) in devInfo.devListInfo.deviceList"
                      :header="item.floorName" style="border: none">
      <template #extra>总数:{{ item.total }} 在线:{{ item.online }}
        掉线:{{ Number(item.total) - Number(item.online) }}
      </template>
      <a-descriptions :column="3" class="labelCenter" v-if="item.devices.length">
        <a-descriptions-item v-for="(item2,index2) in item.devices" :key="index2">
          <a-space @click="sing.changeCurrentCode(item2.uniqueCode,item.devices)"
                   :style="sing.currentCode.qrCode === item2.uniqueCode ? 'background:pink' :''">
            <a-image :preview="false" :width="25" :src="devImage(item2.deviceType)"></a-image>
            <span class="code" style="color: #70b1e3; " v-if="item2.online === 1">{{ item2.uniqueCode }}</span>
            <s class="code" v-else>{{ item2.uniqueCode }}</s>
            <a-image :preview="false" :width="25" :src="devTagUrl(item2.label)" v-if="item2.label !== 0"></a-image>
            <span v-else></span>
          </a-space>
        </a-descriptions-item>
      </a-descriptions>
      <a-empty :image="simpleImage" v-else/>
    </a-collapse-panel>
  </a-collapse>
  <a-empty :image="simpleImage" v-else/>
  <v-map v-if="map" :visible="map" :full = 'true' :channel = "true" @showMap="showMap"/>
  <v-park-error-table v-if="parkMap" :visible="parkMap" @showMap="showParkMap"/>
  <v-project v-if="projectState" :visible = 'projectState' @showProject="openProject"/>
</template>

<script setup>
import {createVNode, h, onMounted, ref} from "vue";
import {
  EnvironmentOutlined,
  RedoOutlined,
  CaretRightOutlined,
  CheckOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FundProjectionScreenOutlined,
  CreditCardOutlined
} from "@ant-design/icons-vue";
import deviceData from "@/layouts/admin-sidebar/modal/deviceData";
import userStore from "@/stores/user"
import devStore from "@/stores/devStore"
import {Empty, Modal} from 'ant-design-vue';
import singleDev from "@/stores/singleDev";
// import load from "@/common/load";
import {axiosPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import mqttTool from "@/utils/mqtt";
import VMap from "@/components/v-map.vue";
import VProject from "@/components/devInfo/v-project.vue";
import VParkErrorTable from "@/components/v-parkErrorTable.vue";

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

let user = userStore()
let dev = devStore()
let sing = singleDev()

let projectState = ref(false);

let openProject = (val)=>{
  projectState.value = val;
}

let editState = ref(false);

let showMap = (val) => {
  map.value = val
}
let showParkMap = (val) => {
  parkMap.value = val
}

let editStart = () => {
  editState.value = true;
  codeValue.value = sing.currentCode.qrCode;
}
let codeValue = ref('');
let submit = async () => {
  if (codeValue.value && codeValue.value !== sing.currentCode.qrCode) {
    // sing.changeCurrentCode(codeValue.value, [])
    // try {
      let result = await axiosPost(api.queryCode, {
        "userId": user.userId,
        "uniqueCode": codeValue.value
      })
      if (result.result === '1') {
        let {buildId, floorId, buildName} = result.data;
        if (buildId === user.buildId) {
          dev.devListInfo.deviceList.forEach(item =>{
            if(item.floorId === floorId){
              sing.changeCurrentCode(codeValue.value,item.devices,'list')
            }
          })
          editState.value = false;
          return
        }
        let buildData = user.buildList.filter(item => {
          return item.buildId === buildId;
        })
        if (buildData[0]) {
          Modal.confirm({
            title: `是否确认切换当前项目到${buildName}?`,
            icon: createVNode(ExclamationCircleOutlined),
            centered: true,
            onOk: async () => {
              let {buildName, buildId, systemVersion, cityName} = buildData[0];
              user.buildName = buildName;
              user.buildId = buildId;
              user.systemVersion = systemVersion;
              user.cityName = cityName;
              await dev.reset();
              await devStore().$reset(); //重置用户数据的状态管理器
              await dev.getDevStoreList();
              await singleDev().$reset();
              for (let i = 0; i < dev.devListInfo.deviceList.length; i++) {
                if (floorId === dev.devListInfo.deviceList[i].floorId) {
                  sing.changeCurrentCode(codeValue.value, dev.devListInfo.deviceList[i].devices)
                }
              }
              dev.mode = "information";
              if (mqttTool.client.connected) {
                if (mqttTool.subscribeSuccess) {
                  mqttTool.doUnSubscribe()
                }
              }

            },
            onCancel() {
            },
          });
        }
      } else {
        sing.changeCurrentCode(codeValue.value, [], 'nolist')
      }
    // } catch (e) {
    //   console.log(e)
    //   load.error("查询二维码失败...")
    // }
  }
  editState.value = false;
}
onMounted(() => {
  codeValue.value = sing.currentCode.qrCode
})

let {
  allDev,
  modularDev,
  size,
  activeKey,
  beefindMap,
  devInfo,
  devKey,
  devImage,
  devTagUrl,
  handleKey,
  map,
  parkMap,
  beefindParkMap
} = deviceData();
</script>
<style>
.labelCenter {
  padding: 0 15px;
}

.devBox > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
}
</style>
<style scoped lang="scss">
.code {
  cursor: pointer;
}
</style>
